"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrOptions = void 0;
var vue_1 = require("vue");
var PlayerInputFactory_1 = require("./PlayerInputFactory");
var i18n_1 = require("../directives/i18n");
var Button_1 = require("../components/common/Button");
var PreferencesManager_1 = require("./PreferencesManager");
var unique = 0;
exports.OrOptions = vue_1.default.component('or-options', {
    props: {
        player: {
            type: Object,
        },
        players: {
            type: Array,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            selectedOption: 0,
        };
    },
    methods: {
        saveData: function () {
            var componentInstance = this.$data.childComponents[this.$data.selectedOption].componentInstance;
            if (componentInstance !== undefined) {
                if (componentInstance.saveData instanceof Function) {
                    componentInstance.saveData();
                    return;
                }
            }
            throw new Error('Unexpected unable to save data');
        },
    },
    render: function (createElement) {
        var _this = this;
        unique++;
        this.$data.childComponents = [];
        var children = [];
        if (this.showtitle) {
            children.push(createElement('label', [
                createElement('div', i18n_1.$t(this.playerinput.title)),
            ]));
        }
        var optionElements = [];
        if (this.playerinput.options === undefined) {
            throw new Error('no options provided for OrOptions');
        }
        this.playerinput.options.forEach(function (option, idx) {
            var domProps = {
                name: 'selectOption' + unique,
                type: 'radio',
                value: String(idx),
            };
            var displayStyle = _this.$data.selectedOption === idx ? 'block' : 'none';
            var subchildren = [];
            if (_this.$data.selectedOption === idx) {
                domProps.checked = true;
            }
            subchildren.push(createElement('label', { 'class': 'form-radio' }, [
                createElement('input', {
                    domProps: domProps,
                    on: {
                        change: function (event) {
                            _this.selectedOption = Number(event.target.value);
                        },
                    },
                }),
                createElement('i', { 'class': 'form-icon' }),
                createElement('span', i18n_1.$t(option.title)),
            ]));
            _this.$data.childComponents.push(new PlayerInputFactory_1.PlayerInputFactory().getPlayerInput(createElement, _this.players, _this.player, option, function (out) {
                var copy = [[String(idx)]];
                for (var i = 0; i < out.length; i++) {
                    copy.push(out[i].slice());
                }
                _this.onsave(copy);
            }, option.buttonLabel === 'Sell' || option.buttonLabel === 'Play card', false));
            subchildren.push(createElement('div', { style: { display: displayStyle, marginLeft: '30px' } }, [
                _this.$data.childComponents[_this.$data.childComponents.length - 1],
            ]));
            optionElements.push(subchildren[subchildren.length - 1]);
            var showOption = true;
            if (option.showOnlyInLearnerMode && !PreferencesManager_1.PreferencesManager.loadBoolean('learner_mode')) {
                showOption = false;
            }
            if (showOption) {
                children.push(createElement('div', subchildren));
                if (_this.showsave && _this.$data.selectedOption === idx && option.buttonLabel !== 'Sell' && option.buttonLabel !== 'Play card') {
                    children.push(createElement('div', {
                        'style': { 'margin': '5px 30px 10px' },
                        'class': 'wf-action',
                    }, [
                        createElement(Button_1.Button, {
                            props: {
                                title: i18n_1.$t(option.buttonLabel),
                                type: 'submit',
                                size: 'normal',
                                onClick: function () {
                                    _this.saveData();
                                },
                                danger: option.buttonDanger,
                            },
                        }),
                    ]));
                }
            }
        });
        return createElement('div', { 'class': 'wf-options' }, children);
    },
});
//# sourceMappingURL=OrOptions.js.map